import React from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import Select from "react-select";
import moment from "moment";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Col,
  Tab,
  Modal,
  Row,
  Accordion,
} from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import { useDispatch, useSelector } from "react-redux";
import { Document, Page, pdfjs } from "react-pdf";
import { revisiPengajuan } from "stores/Pengajuan/function";
import Moment from "moment";
import { getAllPengajuan } from "stores/Pengajuan/function";
import { number } from "prop-types";
import { updateStatusManual } from "stores/Pengajuan/function";
import CurrencyInput from "react-currency-input-field";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { getPengajuanByIdPengajuan } from "stores/Pengajuan/function";
import { pengajuanUlangDokumen } from "stores/Pengajuan/function";
import { pengajuanKeKoordinator } from "stores/Pengajuan/function";
import Scoring from "./Scoring";
import { cekScoring } from "stores/Pengajuan/function";
import { pengajuanBPD } from "stores/PengajuanKoor/function";

function indexSteps() {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  // console.log(pengajuan, "LLLLL");
  const valDetailPengajuanById = pengajuan.listPengajuanById;
  // console.log(valDetailPengajuanById, "MMMM");
  const auth = useSelector((state) => state.authReducer);
  // console.log(pengajuan, "DARI STORE");
  const [listUrlDokumen, setListUrlDokumen] = React.useState([]);
  const valDetailStepEnam = !pengajuan.detailPengajuan.stepEnam
    ? []
    : pengajuan.detailPengajuan.stepEnam;
  const valDetail = pengajuan.detailPengajuan;
  const urlPreview = pengajuan.urlDokumen;
  const judulPdf = pengajuan.titlePreview;
  const [modalRevisi, setModalRevisi] = React.useState(false);
  const [modalCekScoring, setModalCekScoring] = React.useState(false);
  const [keterangan, setKeterangan] = React.useState("");
  const [idPengajuan, setIdPengajuan] = React.useState("");
  const [modalUpdateStatus, setModalUpdateStatus] = React.useState(false);
  const [keteranganUpdate, setKeteranganUpdate] = React.useState("");
  const [nominalPencairan, setNominalPencairan] = React.useState("");
  const [noAkad, setNoAkad] = React.useState("");
  const [nik, setNik] = React.useState("");
  const [tanggalAkad, setTanggalAkad] = React.useState("");
  const [noAgenda, setNoAgenda] = React.useState("");
  const [tanggalAgenda, setTanggalAgenda] = React.useState("");
  const [status, setStatus] = React.useState("");

  // const createAtStepEmpat = Moment(valDetail.stepEmpat.createAt).format(
  //   "YYYY-MM-DD"
  // );
  // const jmlh_tanggungan_istri = valDetail.jumlahTanggunganPasangan;
  React.useEffect(() => {
    let tmp = [];
    Object.entries(valDetailStepEnam).forEach(([key, value]) => {
      if (
        key != "_id" &&
        key != "id_pinjaman" &&
        key != "createdAt" &&
        key != "updatedAt"
      ) {
        tmp.push({
          key: key,
          url: value,
        });
      }
    });
    setListUrlDokumen(tmp);
  }, []);

  // const ajukanPengajuan = () => {
  //   Swal.fire({
  //     title: "Konfirmasi Pengajuan",
  //     text: "Pastikan data yang anda ajukan benar !!!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Ya, Ajukan",
  //     cancelButtonText: "Batal",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       pengajuanBPD({
  //         idPengajuan: valDetail.id_pinjaman,
  //       })
  //         .then((response) => {
  //           if (response.data.status === 200) {
  //             dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
  //             Swal.fire({
  //               title: "Berhasil",
  //               text: response.data.message,
  //               icon: "success",
  //             });
  //           } else {
  //             Swal.fire({
  //               title: "Error",
  //               text: response.data.message,
  //               icon: "error",
  //             });
  //           }
  //         })
  //         .catch((err) => {
  //           console.log("ERRORRRRR", err);
  //           Swal.fire({
  //             title: "Error",
  //             text: "Terjadi kesalahan saat mengajukan pengajuan.",
  //             icon: "error",
  //           });
  //         });
  //     }
  //   });
  // };

  const ajukanPengajuan = () => {
    Swal.fire({
      title: "Konfirmasi Pengajuan",
      text: "Pastikan data yang anda ajukan benar !!!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Ajukan",
      cancelButtonText: "Batal",
      allowOutsideClick: () => !Swal.isLoading(),
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise((resolve) => {
          pengajuanBPD({
            idPengajuan: valDetail.id_pinjaman,
          })
            .then((response) => {
              console.log("STATUS", response);
              if (response.data.status === 200) {
                dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
                Swal.fire({
                  title: "Berhasil",
                  text: response.data.data.message,
                  icon: "success",
                  showConfirmButton: false,
                  timer: 2000,
                });
                getPengajuanByIdPengajuan(dispatch, {
                  idPengajuan: valDetail.id_pinjaman,
                }).then((response) => {
                  if (response.status === 200) {
                    dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
                    dispatch({
                      type: "SET_DETAIL_PENGAJUAN",
                      data: response.data.data[0],
                    });
                  }
                });
              } else {
                Swal.fire({
                  title: "Error",
                  text: response.data.data.message,
                  icon: "error",
                });
                getPengajuanByIdPengajuan(dispatch, {
                  idPengajuan: valDetail.id_pinjaman,
                }).then((response) => {
                  if (response.status === 200) {
                    dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
                    dispatch({
                      type: "SET_DETAIL_PENGAJUAN",
                      data: response.data.data[0],
                    });
                  }
                });
              }
              resolve();
            })
            .catch((err) => {
              Swal.fire({
                title: "Error",
                text: "Terjadi kesalahan saat mengajukan pengajuan.",
                icon: "error",
              });
              resolve();
            });
        });
      },
    });
  };

  // const ajukanUlangDokumen = () => {
  //   Swal.fire({
  //     title: "Konfirmasi Pengajuan",
  //     text: "Pastikan data yang anda ajukan benar !!!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Ya, Ajukan",
  //     cancelButtonText: "Batal",
  //     allowOutsideClick: () => !Swal.isLoading(),
  //     showLoaderOnConfirm: true,
  //     preConfirm: () => {
  //       return new Promise((resolve) => {
  //         pengajuanUlangDokumen({
  //           idPengajuan: valDetail.id_pinjaman,
  //         })
  //           .then((response) => {
  //             if (response.data.status === 200) {
  //               dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
  //               Swal.fire({
  //                 title: "Berhasil",
  //                 text: response.data.message,
  //                 icon: "success",
  //               });
  //               getPengajuanByIdPengajuan(dispatch, {
  //                 idPengajuan: valDetail.id_pinjaman,
  //               }).then((response) => {
  //                 if (response.status === 200) {
  //                   dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
  //                   dispatch({
  //                     type: "SET_DETAIL_PENGAJUAN",
  //                     data: response.data.data[0],
  //                   });
  //                 }
  //               });
  //             } else {
  //               dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
  //               Swal.fire({
  //                 title: "Error",
  //                 text: response.data.message,
  //                 icon: "error",
  //               });
  //               getPengajuanByIdPengajuan(dispatch, {
  //                 idPengajuan: valDetail.id_pinjaman,
  //               }).then((response) => {
  //                 if (response.status === 200) {
  //                   dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
  //                   dispatch({
  //                     type: "SET_DETAIL_PENGAJUAN",
  //                     data: response.data.data[0],
  //                   });
  //                 }
  //               });
  //             }
  //             resolve();
  //           })
  //           .catch((err) => {
  //             Swal.fire({
  //               title: "Error",
  //               text: "Terjadi kesalahan saat mengajukan pengajuan.",
  //               icon: "error",
  //             });
  //             resolve();
  //           });
  //       });
  //     },
  //   });
  // };

  // const ajukanUlangDokumen = () => {
  //   Swal.fire({
  //     title: "Konfirmasi Pengajuan",
  //     text: "Pastikan data yang anda ajukan benar !!!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Ya, Ajukan",
  //     cancelButtonText: "Batal",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       pengajuanUlangDokumen({
  //         idPengajuan: valDetail.id_pinjaman,
  //       })
  //         .then((response) => {
  //           if (response.data.status === 200) {
  //             dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
  //             Swal.fire({
  //               title: "Berhasil",
  //               text: response.data.message,
  //               icon: "success",
  //             });
  //           } else {
  //             Swal.fire({
  //               title: "Error",
  //               text: response.data.message,
  //               icon: "error",
  //             });
  //           }
  //         })
  //         .catch((err) => {
  //           console.log("ERRORRRRR", err);
  //           Swal.fire({
  //             title: "Error",
  //             text: "Terjadi kesalahan saat mengajukan pengajuan.",
  //             icon: "error",
  //           });
  //         });
  //     }
  //   });
  // };

  // const ajukanPengajuan = () => {
  //   pengajuanBPD({
  //     idPengajuan: valDetail.id_pinjaman,
  //   })
  //     .then((response) => {
  //       console.log("HASIL PENGAJUAN", response);
  //     })
  //     .catch((err) => {
  //       console.log("ERRORRRRR", err);
  //     });
  // };

  const handleClick = (idPengajuanValue) => {
    setIdPengajuan(idPengajuanValue);
    dispatch({ type: "SET_CLOSE_TAB", data: false });
    dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
    dispatch({ type: "SET_DETAIL_PENGAJUAN_LAMA", data: true });
    localStorage.removeItem("detailPengajuan");
  };

  const submitRevisi = () => {
    if (keterangan === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Keterangan tidak boleh kosong",
      });
    } else {
      revisiPengajuan({
        idPengajuan: idPengajuan,
        keterangan: keterangan,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
          }).then(() => {
            dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
          });
          setTimeout(() => {
            Swal.close();
          }, 5000);
          setModalRevisi(false);
          getAllPengajuan(dispatch, { status: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const submitCekScoring = () => {
    cekScoring({
      bapLoan: idPengajuan,
      nik: nik,
    }).then((response) => {
      if (response.status === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
        });
        setTimeout(() => {
          Swal.close();
        }, 5000);
        setModalCekScoring(false);
        getAllPengajuan(dispatch, { status: "" });
      } else if (response.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.message,
        });
      }
    });
  };

  const submitUpdateStatus = (e) => {
    e.preventDefault();
    if (status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status tidak boleh kosong",
      });
    } else {
      if (status.value === "Disetujui") {
        if (
          nominalPencairan === 0 ||
          noAkad === "" ||
          tanggalAkad === "" ||
          noAgenda === "" ||
          tanggalAgenda === ""
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Wajib di isi semua!",
          });
        } else {
          updateStatusManual({
            idPinjaman: idPengajuan,
            statusPengajuan: status.value,
            nominalPencairan: nominalPencairan,
            noAkad: noAkad,
            noAgenda: noAgenda,
            tglAkad: tanggalAkad,
            tglAgenda: tanggalAgenda,
          }).then((response) => {
            // console.log(response, "TESSSSSSSSSSSSSSS");
            if (response.data.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
              }).then((response) => {
                setModalUpdateStatus(false);
                setStatus("");
                setNoAgenda("");
                setNoAkad("");
                setNominalPencairan("");
                setTanggalAgenda("");
                setTanggalAkad("");
                getAllPengajuan(dispatch, { status: "" });
                dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
                dispatch({ type: "SET_CLOSE_TAB", data: false });
              });
              setTimeout(() => {
                Swal.close();
              }, 1000);
            } else if (response.data.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          });
        }
      } else {
        if (
          (status.value === "Ditolak" || status.value === "Revisi") &&
          keteranganUpdate === ""
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Keterangan tidak boleh kosong",
          });
        } else {
          updateStatusManual({
            idPinjaman: idPengajuan,
            statusPengajuan: status.value,
            keterangan: keteranganUpdate,
            nominalPencairan: nominalPencairan,
            noAkad: noAkad,
            tglAkad: tanggalAkad,
            noAgenda: noAgenda,
            tglAgenda: tanggalAgenda,
          }).then((response) => {
            if (response.data.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
              }).then(() => {
                setModalUpdateStatus(false);
                setKeterangan("");
                setStatus("");
                setNoAgenda("");
                setNoAkad("");
                setNominalPencairan("");
                setTanggalAgenda("");
                setTanggalAkad("");
                getAllPengajuan(dispatch, {
                  status: "",
                  page: 1,
                  limit: 10,
                  cari: "",
                });
                dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
                dispatch({ type: "SET_CLOSE_TAB", data: false });
              });
              setTimeout(() => {
                Swal.close();
              }, 1000);
            } else if (response.data.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          });
        }
      }
    }
  };

  const handleCloseModalUpdatStatus = () => {
    setStatus("");
    setKeterangan("");
    setNominalPencairan("");
    setNoAkad("");
    setTanggalAkad("");
    setNoAgenda("");
    setTanggalAgenda("");
  };

  const statusStyle = (status) => {
    switch (status) {
      case "Menunggu Konfirmasi":
        return { backgroundColor: "#FFF5CD", textColor: "#FFAF05" };
      case "Diajukan":
        return { backgroundColor: "#BAD9FD", textColor: "#1776F1" };
      case "Diajukan (File Gagal Terkirim)":
        return { backgroundColor: "#ECE6FA", textColor: "#5729CE" };
      case "Diproses":
        return { backgroundColor: "#fcceb3", textColor: "#fa5d02" };
      case "Diproses (File Gagal Terkirim)":
        return { backgroundColor: "#ECC7BE", textColor: "#9F2305" };
      case "Disetujui":
        return { backgroundColor: "#E3FCDB", textColor: "#5AC967" };
      case "Revisi":
        return { backgroundColor: "#FFE2E6", textColor: "#FF2B4B" };
      case "Ditolak":
        return { backgroundColor: "#E10F00", textColor: "#ffffff" };
      default:
        return {};
    }
  };

  const options = [
    {
      value: "",
      label: "Pilih Status",
      isDisabled: true,
    },
    // {
    //   value: "Menunggu Konfirmasi",
    //   label: "Menunggu Konfirmasi",
    // },
    {
      value: "Revisi",
      label: "Revisi",
    },
    {
      value: "Diproses",
      label: "Diproses",
    },
    {
      value: "Disetujui",
      label: "Disetujui",
    },
    {
      value: "Ditolak",
      label: "Ditolak",
    },
  ];

  // const submitRevisi = () => {
  //   if (keterangan === "") {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Keterangan tidak boleh kosong",
  //     });
  //   } else {
  //     revisiPengajuan({
  //       idPengajuan: idPengajuan,
  //       keterangan: keterangan,
  //     }).then((response) => {
  //       if (response.data.status === 200) {
  //         Swal.fire({
  //           position: "center",
  //           icon: "success",
  //           title: response.data.message,
  //         });
  //         setTimeout(() => {
  //           Swal.close();
  //         }, 5000);
  //         setModalRevisi(false);
  //       } else if (response.data.status === 400) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: response.data.message,
  //         });
  //       }
  //     });
  //   }
  // };

  return (
    <>
      <style>
        {`
          .custom-tab-pills .nav-link {
            color: #475569 !important;
            background-color: #F8FAFC;
            border: 1px solid #E2E8F0;
          }
          .custom-tab-pills .nav-link:hover {
            background-color: #F1F5F9;
            color: #0EA5E9 !important;
          }
          .custom-tab-pills .nav-link.active,
          .custom-tab-pills .show > .nav-link {
            color: #FFFFFF !important;
            background-color: #0EA5E9 !important;
            border-color: #0EA5E9 !important;
            box-shadow: 0 4px 10px rgba(14, 165, 233, 0.3) !important;
          }
        `}
      </style>
      <Modal
        size="lg"
        show={modalCekScoring}
        onHide={() => {
          setModalCekScoring(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md={"12"} style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title as="h4" style={{ fontWeight: "bold" }}>
                Cek Scoring
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Col sm="12">
                <label style={{ fontWeight: "bold", color: "black" }}>
                  ID Pengajuan
                </label>
                <Form.Control
                  defaultValue={valDetail.id_pinjaman}
                  disabled
                  placeholder="Company"
                  type="text"
                  onChange={(e) => {
                    setIdPengajuan(e.target.value);
                  }}
                ></Form.Control>
                {""}
                <label style={{ fontWeight: "bold", color: "black" }}>
                  NIK
                </label>
                <Form.Control
                  defaultValue={valDetail.nomorIdentitas}
                  disabled
                  placeholder="Company"
                  type="text"
                  onChange={(e) => {
                    setNik(e.target.value);
                  }}
                ></Form.Control>
              </Col>
            </Card.Body>
            <Card.Footer>
              <Button
                className=" mr-0"
                style={{
                  backgroundColor: "#80AE62",
                  border: 0,
                  fontWeight: "bold",
                }}
                onClick={submitCekScoring}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>

      <Modal
        size="lg"
        show={modalUpdateStatus}
        onHide={() => {
          setModalUpdateStatus(false);
          handleCloseModalUpdatStatus();
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Header>
                      <Card.Title as="h4" style={{ fontWeight: "bold" }}>
                        Update Status
                      </Card.Title>
                    </Card.Header>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            Status
                          </label>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="singleStatus"
                            onChange={(value) => setStatus(value)}
                            options={options}
                            placeholder="Pilih Status"
                          />
                        </Form.Group>
                      </Col>
                      {status.value === "Menunggu Konfirmasi" ||
                      status.value === "Revisi" ||
                      status.value === "Ditolak" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              Keterangan
                            </label>
                            <Form.Control
                              as="textarea"
                              onChange={(e) => {
                                setKeteranganUpdate(e.target.value);
                              }}
                              rows={4}
                              className="form-control"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              Nominal Pencairan
                            </label>
                            <p>
                              <CurrencyInput
                                style={{
                                  padding: 5,
                                  borderRadius: 4,
                                  width: "100%",
                                  height: "40px",
                                  borderWidth: "1px",
                                  borderTopColor: "rgba(227, 227, 227, 0.3)",
                                  borderLeftColor: "rgba(227, 227, 227, 0.3)",
                                  borderBottomColor: "rgba(227, 227, 227, 1)",
                                  borderRightColor: "rgba(227, 227, 227, 1)",
                                }}
                                name="nominal"
                                placeholder="Masukkan nominal"
                                prefix="Rp "
                                onValueChange={(value) => {
                                  setNominalPencairan(value);
                                }}
                              />
                            </p>
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              No Akad
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setNoAkad(e.target.value);
                              }}
                              type="text"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              Tanggal Akad
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setTanggalAkad(e.target.value);
                              }}
                              type="date"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              No Agenda
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setNoAgenda(e.target.value);
                              }}
                              type="text"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              Tanggal Agenda
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setTanggalAgenda(e.target.value);
                              }}
                              type="date"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                    </Row>

                    <Button
                      className="btn-fill pull-right"
                      type="submit"
                      variant="info"
                      onClick={submitUpdateStatus}
                    >
                      Submit
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalRevisi}
        onHide={() => {
          setModalRevisi(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md={"12"} style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title as="h4" style={{ fontWeight: "bold" }}>
                Note Revisi
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Col sm="12">
                <Form.Control
                  as="textarea"
                  rows={4}
                  onChange={(e) => {
                    setKeterangan(e.target.value);
                  }}
                ></Form.Control>
                <Form.Text
                  className="text-muted"
                  style={{ color: "black", fontWeight: "bold" }}
                >
                  Note Revisi Apa Saja Yang Diperlukan
                </Form.Text>
              </Col>
            </Card.Body>
            <Card.Footer>
              <Button
                className="btn-wd mr-0"
                variant="primary"
                onClick={submitRevisi}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>

      <Row>
        <Col md={pengajuan.valueCol} style={{ marginTop: 20 }}>
          <Card
            className="shadow-sm"
            style={{ border: 0, borderRadius: "20px", overflow: "hidden" }}
          >
            <div
              style={{
                padding: "25px 25px 15px 25px",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "15px",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  className="shadow-sm mr-3"
                  type="button"
                  variant="primary"
                  size="md"
                  style={{
                    border: "none",
                    backgroundColor: "#00BFFF",
                    borderRadius: "12px",
                    width: "45px",
                    height: "45px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                  }}
                  onClick={handleClick}
                >
                  <i
                    className="fas fa-arrow-left"
                    style={{ fontSize: "18px" }}
                  ></i>
                </Button>
                <Card.Title
                  as="h3"
                  style={{
                    margin: 0,
                    fontWeight: "800",
                    textTransform: "uppercase",
                    color: "#2C3E50",
                    letterSpacing: "0.5px",
                  }}
                >
                  Detail Pengajuan
                </Card.Title>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                }}
              >
                {auth.role === "super admin" ||
                auth.role === "admin" ||
                auth.role === "koordinator wilayah" ||
                auth.role === "area manager" ||
                auth.role === "supervisor" ? (
                  <>
                    {valDetail?.regisNumber ? (
                      <>
                        <Button
                          disabled={
                            valDetail.statusPengajuan !== "Menunggu Konfirmasi"
                          }
                          style={{
                            cursor:
                              valDetail.statusPengajuan !==
                              "Menunggu Konfirmasi"
                                ? "not-allowed"
                                : "pointer",
                            backgroundColor:
                              valDetail.statusPengajuan !==
                              "Menunggu Konfirmasi"
                                ? "#FEE2E2"
                                : "#FFF1F2",
                            color:
                              valDetail.statusPengajuan !==
                              "Menunggu Konfirmasi"
                                ? "#9CA3AF"
                                : "#E11D48",
                            border:
                              valDetail.statusPengajuan !==
                              "Menunggu Konfirmasi"
                                ? "1px solid #E5E7EB"
                                : "1px solid #FDA4AF",
                            fontWeight: "600",
                            borderRadius: "12px",
                            padding: "10px 24px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                            transition: "all 0.3s ease",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          className="btn-wd mr-3"
                          onMouseEnter={(e) => {
                            if (
                              valDetail.statusPengajuan ===
                              "Menunggu Konfirmasi"
                            ) {
                              e.currentTarget.style.backgroundColor = "#FFE4E6";
                              e.currentTarget.style.transform =
                                "translateY(-2px)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (
                              valDetail.statusPengajuan ===
                              "Menunggu Konfirmasi"
                            ) {
                              e.currentTarget.style.backgroundColor = "#FFF1F2";
                              e.currentTarget.style.transform = "translateY(0)";
                            }
                          }}
                          onClick={() => {
                            setIdPengajuan(valDetail.id_pinjaman);
                            setModalRevisi(true);
                          }}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ marginRight: "8px" }}
                          ></i>
                          Revisi
                        </Button>
                        <Button
                          disabled={
                            valDetail.statusPengajuan !== "Menunggu Konfirmasi"
                          }
                          style={{
                            cursor:
                              valDetail.statusPengajuan !==
                              "Menunggu Konfirmasi"
                                ? "not-allowed"
                                : "pointer",
                            background:
                              valDetail.statusPengajuan !==
                              "Menunggu Konfirmasi"
                                ? "#E5E7EB"
                                : "linear-gradient(135deg, #0EA5E9 0%, #2563EB 100%)",
                            color:
                              valDetail.statusPengajuan !==
                              "Menunggu Konfirmasi"
                                ? "#9CA3AF"
                                : "white",
                            border: "none",
                            fontWeight: "600",
                            borderRadius: "12px",
                            padding: "10px 28px",
                            boxShadow:
                              valDetail.statusPengajuan !==
                              "Menunggu Konfirmasi"
                                ? "none"
                                : "0 4px 12px rgba(37, 99, 235, 0.25)",
                            transition: "all 0.3s ease",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          className="btn-wd"
                          onMouseEnter={(e) => {
                            if (
                              valDetail.statusPengajuan ===
                              "Menunggu Konfirmasi"
                            ) {
                              e.currentTarget.style.boxShadow =
                                "0 6px 16px rgba(37, 99, 235, 0.4)";
                              e.currentTarget.style.transform =
                                "translateY(-2px)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (
                              valDetail.statusPengajuan ===
                              "Menunggu Konfirmasi"
                            ) {
                              e.currentTarget.style.boxShadow =
                                "0 4px 12px rgba(37, 99, 235, 0.25)";
                              e.currentTarget.style.transform = "translateY(0)";
                            }
                          }}
                          onClick={ajukanPengajuan}
                        >
                          Ajukan
                          <i
                            className="fas fa-paper-plane"
                            style={{ marginLeft: "10px" }}
                          ></i>
                        </Button>
                      </>
                    ) : (
                      <Button
                        disabled={
                          auth.role === "super admin" || auth.role === "admin"
                            ? false
                            : valDetail.statusPengajuan === "Diajukan" ||
                              valDetail.statusPengajuan === "Ditolak" ||
                              valDetail.statusPengajuan ===
                                "Diajukan (File Gagal Terkirim)" ||
                              valDetail.statusPengajuan === "Disetujui" ||
                              valDetail.statusPengajuan === "Revisi"
                        }
                        style={{
                          cursor:
                            auth.role === "super admin" || auth.role === "admin"
                              ? "pointer"
                              : valDetail.statusPengajuan === "Diajukan" ||
                                  valDetail.statusPengajuan === "Ditolak" ||
                                  valDetail.statusPengajuan ===
                                    "Diajukan (File Gagal Terkirim)" ||
                                  valDetail.statusPengajuan === "Disetujui" ||
                                  valDetail.statusPengajuan === "Revisi"
                                ? "not-allowed"
                                : "pointer",
                          backgroundColor: "#06B48B",
                          borderWidth: 0,
                          fontWeight: "bold",
                          borderRadius: "10px",
                          padding: "10px 20px",
                        }}
                        className="shadow-sm btn-wd"
                        size="md"
                        onClick={() => {
                          setIdPengajuan(valDetail.id_pinjaman);
                          setModalUpdateStatus(true);
                        }}
                      >
                        <i className="fas fa-edit mr-2"></i>
                        Update Status Manual
                      </Button>
                    )}
                  </>
                ) : null}
              </div>
            </div>

            <div style={{ padding: "20px 25px 0 25px" }}>
              <div className="row">
                <div className="col-md-12">
                  <Card
                    className="shadow-sm"
                    style={{
                      backgroundColor: statusStyle(valDetail.statusPengajuan)
                        .backgroundColor,
                      borderRadius: "16px",
                      border: "none",
                      overflow: "hidden",
                    }}
                  >
                    <Card.Body
                      style={{
                        padding: "24px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "rgba(255,255,255,0.5)",
                          borderRadius: "14px",
                          width: "60px",
                          height: "60px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "20px",
                          flexShrink: 0,
                        }}
                      >
                        <i
                          className="fas fa-info-circle"
                          style={{
                            fontSize: "30px",
                            color: statusStyle(valDetail.statusPengajuan)
                              .textColor,
                          }}
                        ></i>
                      </div>
                      <div style={{ flex: 1 }}>
                        <h4
                          style={{
                            color: statusStyle(valDetail.statusPengajuan)
                              .textColor,
                            fontWeight: "800",
                            fontSize: "18px",
                            margin: 0,
                            marginBottom: "6px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {valDetail.statusPengajuan}
                        </h4>
                        <p
                          style={{
                            margin: 0,
                            color:
                              valDetail.statusPengajuan === "Ditolak"
                                ? "white"
                                : "#444",
                            fontSize: "15px",
                            fontWeight: "500",
                          }}
                        >
                          {valDetail.statusPengajuan ===
                            "Menunggu Konfirmasi" &&
                            "Pengajuan Anda sedang menunggu untuk tahap pengecekan."}
                          {valDetail.statusPengajuan === "Diproses" &&
                            "Pengajuan sedang dalam proses oleh pihak Bank KALBAR."}
                          {valDetail.statusPengajuan === "Revisi" && (
                            <div
                              style={{
                                textTransform: "capitalize",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  marginBottom: "10px",
                                  fontWeight: "600",
                                }}
                              >
                                {valDetail.history &&
                                valDetail.history.length > 0
                                  ? valDetail.history[0].keterangan
                                  : valDetail.note_reject || "-"}
                              </div>

                              {valDetail.dokumenRevisi &&
                                valDetail.dokumenRevisi.length > 0 && (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      padding: "12px",
                                      backgroundColor: "#FEF2F2",
                                      border: "1px solid #FECACA",
                                      borderRadius: "8px",
                                      width: "100%",
                                    }}
                                  >
                                    <strong
                                      style={{
                                        color: "#DC2626",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <i className="fas fa-exclamation-circle mr-2"></i>
                                      Dokumen yang perlu di-upload ulang:
                                    </strong>
                                    <ul
                                      style={{
                                        margin: "8px 0 0 24px",
                                        color: "#B91C1C",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {valDetail.dokumenRevisi.map(
                                        (dok, idx) => (
                                          <li
                                            key={idx}
                                            style={{ marginBottom: "4px" }}
                                          >
                                            {dok.replace(/_/g, " ")}
                                          </li>
                                        ),
                                      )}
                                    </ul>
                                  </div>
                                )}
                            </div>
                          )}
                          {valDetail.statusPengajuan === "Disetujui" &&
                            "Pengajuan pinjaman telah disetujui oleh pihak Bank KALSEL."}
                          {valDetail.statusPengajuan === "Ditolak" &&
                            "Pengajuan pinjaman telah ditolak oleh pihak Bank KALSEL."}
                          {valDetail.statusPengajuan === "Diajukan" &&
                            "Pengajuan telah diajukan ke pihak Bank KALSEL."}
                          {valDetail.statusPengajuan ===
                            "Diajukan (File Gagal Terkirim)" &&
                            "Data pengajuan berhasil diajukan tetapi file gagal terkirim, coba ajukan ulang."}
                          {valDetail.statusPengajuan ===
                            "Diproses (File Gagal Terkirim)" &&
                            "Data pengajuan berhasil diproses tetapi file gagal terkirim."}
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </div>

            <Card.Body style={{ padding: "0 25px 25px 25px" }}>
              <Tab.Container id="plain-tabs-example" defaultActiveKey="step1">
                <Nav
                  role="tablist"
                  variant="pills"
                  className="mb-4 mt-2 custom-tab-pills"
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    gap: "10px",
                    paddingBottom: "10px",
                    WebkitOverflowScrolling: "touch",
                  }}
                >
                  <Nav.Item>
                    <Nav.Link
                      eventKey="step1"
                      className="shadow-sm"
                      style={{
                        borderRadius: "50px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Informasi Nasabah
                    </Nav.Link>
                  </Nav.Item>
                  {valDetail.statusMenikah === "Menikah" ? (
                    <Nav.Item>
                      <Nav.Link
                        eventKey="step2"
                        className="shadow-sm"
                        style={{
                          borderRadius: "50px",
                          fontWeight: "bold",
                          padding: "10px 20px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Informasi Pasangan
                      </Nav.Link>
                    </Nav.Item>
                  ) : null}
                  <Nav.Item>
                    <Nav.Link
                      eventKey="step3"
                      className="shadow-sm"
                      style={{
                        borderRadius: "50px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Informasi Pekerjaan
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="step4"
                      className="shadow-sm"
                      style={{
                        borderRadius: "50px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Informasi Pinjaman
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="step5"
                      className="shadow-sm"
                      style={{
                        borderRadius: "50px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Informasi Jaminan
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="step6"
                      className="shadow-sm"
                      style={{
                        borderRadius: "50px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Dokumen
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="step1">
                    <Step1 />
                  </Tab.Pane>
                  <Tab.Pane eventKey="step2">
                    <Step2 />
                  </Tab.Pane>

                  <Tab.Pane eventKey="step3">
                    <Step3 />
                  </Tab.Pane>

                  <Tab.Pane eventKey="step4">
                    <Step4 />
                  </Tab.Pane>

                  <Tab.Pane eventKey="step5">
                    <Step5 />
                  </Tab.Pane>
                  <Tab.Pane eventKey="step6">
                    <Step6 />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Card.Body>
          </Card>
        </Col>
        {pengajuan.valueCol === "12" ? null : (
          <>
            <Col md={pengajuan.valueColPrev} style={{ marginTop: 20 }}>
              <Card
                className="shadow-sm"
                style={{ border: 0, borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  style={{
                    padding: "20px 25px",
                    borderBottom: "1px solid #f0f0f0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Button
                    className="shadow-sm mr-3"
                    type="button"
                    variant="danger"
                    size="md"
                    style={{
                      border: "none",
                      borderRadius: "12px",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                    onClick={() => {
                      dispatch({ type: "HIDE_DOKUMEN" });
                    }}
                  >
                    <i
                      className="fas fa-times"
                      style={{ fontSize: "16px" }}
                    ></i>
                  </Button>
                  <Card.Title
                    as="h3"
                    style={{
                      margin: 0,
                      fontWeight: "800",
                      textTransform: "uppercase",
                      color: "#2C3E50",
                      fontSize: "18px",
                    }}
                  >
                    Preview Dokumen
                  </Card.Title>
                </div>

                <Card.Body style={{ padding: 0 }}>
                  {/* {listUrlDokumen.map((val) => {
                    return (
                      <>
                        <label>{val.key}</label>
                      </>
                    );
                  })} */}
                  {/* <label> {judulPdf} </label> */}
                  <iframe src={urlPreview} width="100%" height="700px" />
                </Card.Body>
              </Card>
            </Col>
          </>
        )}
      </Row>

      {valDetail.stepEmpat.tujuanPenggunaan === "2" ? (
        <>
          <Card
            className="shadow-sm"
            style={{ border: 0, borderRadius: "20px", marginTop: "20px" }}
          >
            <Card.Header
              style={{
                borderBottom: "1px solid #f0f0f0",
                padding: "20px 25px",
              }}
            >
              <Card.Title
                as="h3"
                style={{
                  color: "#2C3E50",
                  fontWeight: "800",
                  textTransform: "uppercase",
                  margin: 0,
                  fontSize: "20px",
                }}
              >
                Analisa Slik
              </Card.Title>
            </Card.Header>

            <Card.Body style={{ padding: "25px" }}>
              <Tab.Container id="plain-tabs-example" defaultActiveKey="scoring">
                <Nav
                  role="tablist"
                  variant="pills"
                  className="mb-4 custom-tab-pills"
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  {/* <Nav.Item>
                    <Nav.Link
                      eventKey="ringkasan"
                      style={{ color: "#3090C7", fontWeight: "bold" }}
                    >
                      List Usaha
                    </Nav.Link>
                  </Nav.Item> */}

                  <Nav.Item>
                    <Nav.Link
                      eventKey="scoring"
                      className="shadow-sm"
                      style={{
                        borderRadius: "50px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                      }}
                    >
                      Analisa SLIK
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  {/* <Tab.Pane eventKey="ringkasan">
                    <Ringkasan />
                  </Tab.Pane> */}
                  <Tab.Pane eventKey="scoring">
                    <Scoring />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Card.Body>
          </Card>
        </>
      ) : null}

      <Card
        className="shadow-sm"
        style={{
          border: 0,
          borderRadius: "20px",
          marginTop: "20px",
          marginBottom: "30px",
        }}
      >
        <Card.Header
          style={{ padding: "25px", borderBottom: "1px solid #f0f0f0" }}
        >
          <Card.Title
            as="h3"
            style={{
              color: "#2C3E50",
              fontWeight: "800",
              textTransform: "uppercase",
              textAlign: "center",
              margin: 0,
              fontSize: "20px",
            }}
          >
            History Pengajuan
          </Card.Title>
        </Card.Header>
        <div
          style={{
            maxHeight: "500px",
            overflowY: "auto",
            padding: "20px",
          }}
        >
          <VerticalTimeline lineColor="#e9ecef">
            {valDetail.history.map((item, index) => (
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                contentStyle={{
                  background: "#fff",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                  borderRadius: "16px",
                  padding: "24px",
                  borderTop:
                    item.status === "Menunggu Konfirmasi"
                      ? "5px solid  #FFAF05"
                      : item.status === "Diajukan"
                        ? "5px solid  #1776F1"
                        : item.status === "Diajukan (File Gagal Terkirim)"
                          ? "5px solid  #5729CE"
                          : item.status === "Diproses"
                            ? "5px solid  #fa5d02"
                            : item.status === "Disetujui"
                              ? "5px solid  #5AC967"
                              : item.status === "Revisi"
                                ? "5px solid  #FF2B4B"
                                : "5px solid  #E10F00",
                }}
                contentArrowStyle={{
                  borderRight: "7px solid  #fff",
                }}
                key={index}
                date={moment(item.date).format("DD MMMM YYYY, HH:mm:ss")}
                dateClassName="text-muted"
                iconStyle={{
                  background:
                    item.status === "Menunggu Konfirmasi"
                      ? "#FFAF05"
                      : item.status === "Diajukan"
                        ? "#1776F1"
                        : item.status === "Diajukan (File Gagal Terkirim)"
                          ? "#5729CE"
                          : item.status === "Diproses"
                            ? "#fa5d02"
                            : item.status === "Disetujui"
                              ? "#5AC967"
                              : item.status === "Revisi"
                                ? "#FF2B4B"
                                : "#E10F00",
                  color: "#fff",
                  boxShadow:
                    "0 0 0 4px #fff, inset 0 2px 0 rgba(0,0,0,.08), 0 3px 0 4px rgba(0,0,0,.05)",
                }}
                icon={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    {item.status === "Menunggu Konfirmasi" ? (
                      <i className="fas fa-clock" />
                    ) : item.status === "Diajukan" ? (
                      <i className="fas fa-paper-plane" />
                    ) : item.status === "Diajukan (File Gagal Terkirim)" ? (
                      <i className="fas fa-exclamation-triangle" />
                    ) : item.status === "Diproses" ? (
                      <i className="fas fa-spinner" />
                    ) : item.status === "Disetujui" ? (
                      <i className="fas fa-check" />
                    ) : item.status === "Revisi" ? (
                      <i className="fas fa-edit" />
                    ) : (
                      <i className="fas fa-times" />
                    )}
                  </div>
                }
              >
                <h4
                  className="vertical-timeline-element-title"
                  style={{
                    fontWeight: "800",
                    color:
                      item.status === "Menunggu Konfirmasi"
                        ? "#FFAF05"
                        : item.status === "Diajukan"
                          ? "#1776F1"
                          : item.status === "Diajukan (File Gagal Terkirim)"
                            ? "#5729CE"
                            : item.status === "Diproses"
                              ? "#fa5d02"
                              : item.status === "Disetujui"
                                ? "#5AC967"
                                : item.status === "Revisi"
                                  ? "#FF2B4B"
                                  : "#E10F00",
                    margin: 0,
                    textTransform: "uppercase",
                    fontSize: "16px",
                    letterSpacing: "0.5px",
                  }}
                >
                  {item.status}
                </h4>
                <div
                  style={{
                    marginTop: "16px",
                    padding: "16px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "12px",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#2C3E50",
                        minWidth: "90px",
                        fontSize: "14px",
                      }}
                    >
                      Keterangan
                    </span>
                    <span
                      style={{
                        margin: "0 10px",
                        color: "#2C3E50",
                        fontSize: "14px",
                      }}
                    >
                      :
                    </span>
                    <span
                      style={{
                        color: "#555",
                        fontSize: "14px",
                        flex: 1,
                        lineHeight: "1.5",
                      }}
                    >
                      {!item.keterangan || item.keterangan === ""
                        ? "Tidak ada keterangan tambahan."
                        : item.keterangan}
                    </span>
                  </div>
                </div>
              </VerticalTimelineElement>
            ))}
          </VerticalTimeline>
        </div>
      </Card>
    </>
  );
}

export default indexSteps;
